import styled from 'styled-components';
import { COLORS, BREAKPOINTS, SPACING } from '../../style';

export const DifferencesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md};

  h3 {
    color: ${COLORS.green};
    font-size: 32px;
  }
`;

export const PlusSection = styled.section`
  background: linear-gradient(135deg, rgba(15, 61, 76, 0.03) 0%, rgba(75, 166, 156, 0.03) 100%);
  padding: ${SPACING.md};
  border-radius: 0 0 20px 20px;
  border: 1px solid rgba(75, 166, 156, 0.1);
`;

export const Plus = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: ${SPACING.md};
  margin-top: ${SPACING.md};

  @media (max-width: ${BREAKPOINTS.mobile}) {
    grid-template-columns: 1fr;
  }

  .plus-card {
    background: ${COLORS.white};
    border: 2px solid ${COLORS.green};
    border-radius: 16px;
    padding: ${SPACING.md};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${SPACING.sm};
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(15, 61, 76, 0.08);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, ${COLORS.green} 0%, ${COLORS.blue} 100%);
      transform: scaleX(0);
      transition: transform 0.3s ease;
    }

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 12px 24px rgba(15, 61, 76, 0.15);
      border-color: ${COLORS.blue};

      &::before {
        transform: scaleX(1);
      }

      .icon-wrapper {
        transform: scale(1.1) rotate(5deg);
        background: ${COLORS.green};
        
        svg {
          color: ${COLORS.white};
        }
      }
    }

    .icon-wrapper {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      background: linear-gradient(135deg, rgba(75, 166, 156, 0.1) 0%, rgba(15, 61, 76, 0.1) 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;

      svg {
        font-size: 26px;
        color: ${COLORS.green};
        transition: all 0.3s ease;
      }
    }

    p {
      color: ${COLORS.blue};
      font-weight: 600;
      font-size: 16px;
      text-align: center;
      line-height: 1.5;
      margin: 0;
    }
  }
`;

export const IndustriesSection = styled.section`
  padding: ${SPACING.sm} 0;
`;

export const Industries = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: ${SPACING.md};
  margin-top: ${SPACING.md};

  @media (max-width: ${BREAKPOINTS.mobile}) {
    grid-template-columns: 1fr;
  }
`;